import EmptyRow from './EmptyRow';

export default EmptyRow;
